var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { Equals, IsBoolean, IsOptional, IsString, Matches, MaxLength, MinLength, } from 'class-validator';
import { countryRegex } from '../../countries.js';
import { validAlphaNumericRegex, validNumericRegex } from '../../user/const/validRegex.js';
/**
 * „Praxis eröffnen“ (#1832): an Account opens an office of its own. The office
 * and its first location; the new admin's name comes from the Account, so
 * there is no name field. The office terms of use and the processing contract
 * are accepted here, in the wizard's last step.
 */
export class OpenOfficeDto {
    officeName;
    officeStreet;
    officeZipcode;
    officeTown;
    officeCountry;
    officeSubdivisionCode;
    usesSeparateInvoiceAddress;
    officeCompanyNameForInvoice;
    officeStreetForInvoice;
    officeZipcodeForInvoice;
    officeTownForInvoice;
    officeCountryForInvoice;
    /** Recorded on the new admin Person, like every Person's newsletter choice. */
    agreedNewsletter;
    /** The office terms of use: recorded for the new admin Person (#1824). */
    acceptedTermsOfUse;
    /** The processing contract (AVV): recorded with version and IP for the new office. */
    acceptedProcessingContract;
}
__decorate([
    IsString(),
    MinLength(1),
    MaxLength(255),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeName", void 0);
__decorate([
    IsString(),
    Matches(validAlphaNumericRegex),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeStreet", void 0);
__decorate([
    IsString(),
    MinLength(4),
    MaxLength(5),
    Matches(validNumericRegex),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeZipcode", void 0);
__decorate([
    IsString(),
    Matches(validAlphaNumericRegex),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeTown", void 0);
__decorate([
    IsString(),
    Matches(countryRegex),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeCountry", void 0);
__decorate([
    IsString(),
    MaxLength(8),
    IsOptional(),
    __metadata("design:type", Object)
], OpenOfficeDto.prototype, "officeSubdivisionCode", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], OpenOfficeDto.prototype, "usesSeparateInvoiceAddress", void 0);
__decorate([
    IsString(),
    MaxLength(255),
    Matches(validAlphaNumericRegex),
    IsOptional(),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeCompanyNameForInvoice", void 0);
__decorate([
    IsString(),
    Matches(validAlphaNumericRegex),
    IsOptional(),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeStreetForInvoice", void 0);
__decorate([
    IsString(),
    MinLength(4),
    MaxLength(5),
    Matches(validNumericRegex),
    IsOptional(),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeZipcodeForInvoice", void 0);
__decorate([
    IsString(),
    Matches(validAlphaNumericRegex),
    IsOptional(),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeTownForInvoice", void 0);
__decorate([
    IsString(),
    Matches(countryRegex),
    IsOptional(),
    __metadata("design:type", String)
], OpenOfficeDto.prototype, "officeCountryForInvoice", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], OpenOfficeDto.prototype, "agreedNewsletter", void 0);
__decorate([
    Equals(true),
    __metadata("design:type", Boolean)
], OpenOfficeDto.prototype, "acceptedTermsOfUse", void 0);
__decorate([
    Equals(true),
    __metadata("design:type", Boolean)
], OpenOfficeDto.prototype, "acceptedProcessingContract", void 0);
export class OpenedOfficeDto {
    /** The new office; the frontend switches into it. */
    officeId;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OpenedOfficeDto.prototype, "officeId", void 0);
//# sourceMappingURL=open-office.dto.js.map